import {HttpError} from '@hconnect/common/types'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {useAxios} from '../hooks'
import {AssetConfigurationDto} from '../types'

import {usePlantUpmId} from './useGetPlantUpmId'

export const GetAssetConfigQueryKey = 'asset-config'

// TODO: might be replaced with the one from kilnfeature
// (https://jira.heidelbergcement.com/browse/HCP-97660)
export const useGetAssetConfig = (assetId: string) => {
  const axiosInstance = useAxios()
  const plantUpmId = usePlantUpmId()

  return useQuery<AssetConfigurationDto, AxiosError<HttpError>>({
    queryKey: [GetAssetConfigQueryKey, plantUpmId, assetId],
    queryFn: async () => {
      const path = `asset-config/kms-data/plant/${plantUpmId}/upm-type/Department`
      return (
        await axiosInstance.get<AssetConfigurationDto>(path, {
          params: {
            typeUpmId: assetId
          }
        })
      ).data
    },
    // if config not created yet, we will get 404
    throwOnError: (error) => error?.response?.status !== 404,
    retry: (retryCount, error) => error?.response?.status !== 404 && retryCount < 3,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: plantUpmId !== undefined && assetId !== undefined
  })
}
